/* ==========================================================================
   Accordion
   ========================================================================== */
(function () {
  function setHeight(collapse, open) {
    if (!collapse) return;
    if (open) {
      collapse.style.maxHeight = "none";
      var h = collapse.scrollHeight;
      collapse.style.maxHeight = "0px";
      collapse.getBoundingClientRect();
      collapse.style.maxHeight = h + "px";
    } else {
      collapse.style.maxHeight = collapse.scrollHeight + "px";
      collapse.getBoundingClientRect();
      collapse.style.maxHeight = "0px";
    }
  }

  function initAccordion(accordion) {
    if (accordion.dataset.initialized) return;

    var items = Array.prototype.slice.call(
      accordion.querySelectorAll(":scope > [data-accordion-item]")
    );
    var isMulti = accordion.hasAttribute("data-multi");

    // Force first item to be expanded if none is marked as expanded
    var hasExpanded = items.some(function (item) {
      return item.getAttribute("data-expanded") === "true";
    });
    if (!hasExpanded && items.length > 0) {
      items[0].setAttribute("data-expanded", "true");
    }

    items.forEach(function (item) {
      var collapse = item.querySelector("[data-accordion-collapse]");
      var header = item.querySelector("[data-accordion-header]");
      var isOpen = item.getAttribute("data-expanded") === "true";

      if (collapse) {
        collapse.style.overflow = "hidden";
        collapse.style.transition = "none";
        collapse.style.maxHeight = isOpen ? collapse.scrollHeight + "px" : "0px";
        if (isOpen) collapse.classList.add("is-open");
        requestAnimationFrame(function () {
          collapse.style.transition = "";
        });
      }

      if (header && isOpen) {
        header.classList.add("is-active");
      }
    });

    items.forEach(function (item) {
      var header = item.querySelector("[data-accordion-header]");
      if (!header) return;

      header.addEventListener("click", function () {
        var collapse = item.querySelector("[data-accordion-collapse]");
        var isOpen = item.getAttribute("data-expanded") === "true";

        if (!isMulti) {
          items.forEach(function (other) {
            if (other === item) return;
            var oc = other.querySelector("[data-accordion-collapse]");
            var oh = other.querySelector("[data-accordion-header]");
            other.setAttribute("data-expanded", "false");
            if (oh) oh.classList.remove("is-active");
            if (oc) oc.classList.remove("is-open");
            setHeight(oc, false);
          });
        }

        var nowOpen = !isOpen;
        item.setAttribute("data-expanded", String(nowOpen));
        nowOpen
          ? header.classList.add("is-active")
          : header.classList.remove("is-active");
        if (collapse) {
          nowOpen
            ? collapse.classList.add("is-open")
            : collapse.classList.remove("is-open");
        }
        setHeight(collapse, nowOpen);

        // Sync tab-nav active state when an accordion item is expanded
        if (nowOpen) {
          var headerText = header.textContent.trim().toLowerCase();
          var tabButtons = document.querySelectorAll(".tab-nav button");
          tabButtons.forEach(function (btn) {
            if (headerText.indexOf(btn.textContent.trim().toLowerCase()) !== -1) {
              tabButtons.forEach(function (otherBtn) {
                otherBtn.classList.remove("is-active");
              });
              btn.classList.add("is-active");
            }
          });
        }
      });
    });

    accordion.dataset.initialized = "true";
  }

  function initTabs() {
    var tabButtons = document.querySelectorAll(".tab-nav button");
    var accordionHeaders = document.querySelectorAll("[data-accordion-header]");
    
    // Set the first tab active on load since first accordion item is expanded by default
    var firstActiveHeader = document.querySelector("[data-accordion-item][data-expanded='true'] [data-accordion-header]");
    if (firstActiveHeader) {
      var txt = firstActiveHeader.textContent.trim().toLowerCase();
      tabButtons.forEach(function (btn) {
        if (txt.indexOf(btn.textContent.trim().toLowerCase()) !== -1) {
          btn.classList.add("is-active");
        }
      });
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var btnText = btn.textContent.trim().toLowerCase();
        var matchedHeader = null;
        
        accordionHeaders.forEach(function (header) {
          var headerText = header.textContent.trim().toLowerCase();
          if (headerText.indexOf(btnText) !== -1) {
            matchedHeader = header;
          }
        });
        
        if (matchedHeader) {
          if (!matchedHeader.classList.contains("is-active")) {
            matchedHeader.click();
          }
          matchedHeader.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
        
        tabButtons.forEach(function (b) {
          b.classList.remove("is-active");
        });
        btn.classList.add("is-active");
      });
    });
  }

  function initAll() {
    document.querySelectorAll("[data-accordion]").forEach(function (a) {
      initAccordion(a);
    });
    initTabs();
  }

  function updateHeights() {
    document.querySelectorAll("[data-accordion-item]").forEach(function (item) {
      if (item.getAttribute("data-expanded") === "true") {
        var collapse = item.querySelector("[data-accordion-collapse]");
        if (collapse) {
          collapse.style.maxHeight = "none";
          collapse.style.maxHeight = collapse.scrollHeight + "px";
        }
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  window.addEventListener("load", function () {
    setTimeout(updateHeights, 50);
  });

  var resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateHeights, 300);
  });

  // Shopify theme editor integration
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('section-build-your-space')) {
      initAll();
      setTimeout(updateHeights, 50);
    }
  });
})();
